// Tagesmeldungen: die Tage, die Mitarbeiter in der App an die Bauleitung senden ("An Bauleitung senden").
// Die Bauleitung liest sie hier, wie sie gesendet wurden, und macht im Bericht-Editor einen Bericht daraus.
export default {
  overview: {
    title: "Tagesmeldungen",
    subtitle: "Von Mitarbeitern in der App gesendete Tage, zum Prüfen und Übernehmen als Bericht.",
    getApp: "Lewara-App holen",
    search: "Baustelle, Absender oder Text suchen",
    headers: {
      date: "Tag",
      project: "Baustelle",
      sender: "Gesendet von",
      sent_at: "Gesendet am",
      status: "Status",
      comments: "Kommentare",
      report: "Bericht",
    },
    project_named: "genannt: „{name}“",
    no_project: "Keine Baustelle",
    comment_after_status: "Neuer Kommentar nach der Übernahme",
    filter: {
      status: "Status",
      all: "Alle",
    },
  },
  status: {
    OPEN: "Offen",
    CONVERTED: "Übernommen",
    DISMISSED: "Verworfen",
    INTERRUPTED: "Übernahme unterbrochen",
  },
  detail: {
    title: "Tagesmeldung",
    heading: "Tagesmeldung vom {date}",
    sections: {
      summary: "Überblick",
      origin: "Standort",
      weather: "Wetter",
      entries: "Einträge",
    },
    project: "Baustelle",
    changed_meanwhile:
      "Mit der Tagesmeldung ist inzwischen etwas geschehen. Laden Sie sie neu, bevor Sie weiterarbeiten.",
    reload: "Neu laden",
    read_only: "Ihnen fehlt das Recht, aus Tagesmeldungen dieser Baustelle Berichte zu machen.",
    dismissed: "Verworfen am {date}.",
    dismissed_note: "Verworfen am {date}: {note}",
    converted_cr: "Als [[cr]] Nr. {number} übernommen.",
    merged_cr: "In [[cr:den/die/das]] [[cr]] Nr. {number} übernommen.",
    converted_hwr: "Als [[hwr]] Nr. {number} übernommen.",
    report_gone: "Der Bericht wurde inzwischen gelöscht.",
    report_unnamed: "In einen Bericht übernommen, den Sie nicht einsehen dürfen.",
    not_found: "Diese Tagesmeldung gibt es nicht, oder Sie dürfen sie nicht sehen.",
    interrupted:
      "Die Übernahme wurde unterbrochen, ein Bericht ist nicht entstanden. Öffnen Sie die Tagesmeldung wieder, um es erneut zu versuchen.",
    actions: {
      to_cr: "Als [[cr]] übernehmen",
      merge_cr: "[[Cr]] Nr. {number} ergänzen",
      merge_cr_unnamed: "[[Cr]] des Tages ergänzen",
      to_hwr: "Als [[hwr]] übernehmen",
      dismiss: "Verwerfen",
      reopen: "Wieder öffnen",
      open_report: "Bericht öffnen",
    },
  },
  section: {
    times: "Arbeitszeit",
    crew: "Mitarbeiter",
    equipment: "Geräte",
    material: "Material",
    additional_effort: "Zusätzliche Leistungen",
    service: "Leistungen",
    work: "Ausgeführte Arbeiten",
    occurrence: "Besondere Vorkommnisse",
    note: "Hinweise an die Bauleitung",
    task: "Aufgaben",
    weather: "Wetter",
    other: "Weitere Einträge",
  },
  kind: {
    START: "Arbeitsbeginn",
    END: "Feierabend",
    PAUSE: "Pause",
    CREW: "Mitarbeiter",
    EQUIPMENT: "Gerät",
    MATERIAL: "Material",
    ADDITIONAL_EFFORT: "Zusätzliche Leistung",
    SERVICE: "Leistung",
    WORK: "Arbeit",
    OCCURRENCE: "Vorkommnis",
    NOTE: "Hinweis",
    TASK: "Aufgabe",
    WEATHER: "Wetter",
    DATE: "Tag",
    PROJECT: "Baustelle",
  },
  entry: {
    // Ein Name, wie er gesagt wurde, zu dem es in Lewara nichts gibt: was daraus wird, sagt die Zeile darunter
    named: "„{name}“",
    not_found: "Nicht in Lewara gefunden",
    record_new: "Neu",
    record_new_tip: {
      EQUIPMENT: "Wird beim Speichern des Berichts als neue Maschine angelegt, noch ohne Preise",
      MATERIAL: "Wird beim Speichern des Berichts als neues Material angelegt, noch ohne Preise",
      ADDITIONAL_EFFORT: "Wird beim Speichern des Berichts als neue Zusätzliche Leistung angelegt, noch ohne Preise",
    },
    record_created: "Neu angelegt",
    record_created_tip: "Beim Speichern des Berichts angelegt: Öffnen, um Preise und Angaben zu ergänzen",
    gone: "gelöscht",
    unknown: "Eintrag einer neueren App-Version",
    doubt: "In der App nicht bestätigt",
    doubt_low: "Unsicher erkannt, in der App nicht bestätigt",
    doubt_short: "Unsicher",
    automatic: "Automatisch übernommen",
    automatic_times: "Aus der Zeiterfassung übernommen",
    automatic_crew: "Aus der Personalplanung übernommen oder als Absender ergänzt",
    measured: "Am Standort gemessen",
    // Die Abschnitte ohne Eintrag und ohne Antwort, zusammen in einer Zeile
    none_sections: "Ohne Einträge: {sections}",
    // Was der Mitarbeiter mit „heute nicht“ beantwortet hat, stets mit dem, worum es geht
    none_said: {
      START: "Laut Mitarbeiter keine Angabe zum Arbeitsbeginn",
      END: "Laut Mitarbeiter keine Angabe zum Feierabend",
      PAUSE: "Laut Mitarbeiter keine Pause",
      CREW: "Laut Mitarbeiter keine weiteren Mitarbeiter",
      EQUIPMENT: "Laut Mitarbeiter keine Geräte",
      MATERIAL: "Laut Mitarbeiter kein Material",
      ADDITIONAL_EFFORT: "Laut Mitarbeiter keine zusätzlichen Leistungen",
      SERVICE: "Laut Mitarbeiter keine Leistungen",
      WORK: "Laut Mitarbeiter keine ausgeführten Arbeiten",
      OCCURRENCE: "Laut Mitarbeiter keine besonderen Vorkommnisse",
      NOTE: "Laut Mitarbeiter keine Hinweise",
      TASK: "Laut Mitarbeiter keine Aufgaben",
      WEATHER: "Laut Mitarbeiter keine Angaben zum Wetter",
      PROJECT: "Laut Mitarbeiter keine Baustelle",
    },
    // Ein Feld des Überblicks ohne Wert, anstelle des Strichs. Die App leitet nur dazu an, etwas zu nennen: eine
    // übersprungene Frage ist keine eigene Antwort
    unnamed: "Nicht genannt",
    said: "Gesagt: „{text}“",
    people: "Mit {names}",
    hours: "{hours} Std.",
    minutes: "{minutes} Min.",
    device: "Geräte-Nr. {number}",
    own_time: "eigene Zeit {from}–{to}",
    span: "{from}–{to}",
    since: "ab {from}",
    until: "bis {to}",
    to_end: "bis Feierabend",
    since_to_end: "ab {from} bis Feierabend",
    reason: "Grund: {reason}",
    assignee: "Für {name}",
    due: "bis {date}",
    at: {
      START: "Morgens",
      MID: "Mittags",
      END: "Nachmittags",
    },
    // Über einer Stunde des Wetters, wo nur ein kurzes Wort Platz hat
    at_short: {
      START: "Morgens",
      MID: "Mittags",
      END: "Nachm.",
    },
  },
  reason: {
    WEATHER: "Witterung",
    MATERIAL: "Material fehlt",
    EQUIPMENT: "Gerät oder Maschine",
    OTHER_TRADES: "Andere Gewerke",
    CLIENT: "Bauherr oder Planung",
    ACCIDENT: "Unfall",
    OTHER: "Sonstiges",
  },
  dialog: {
    cancel: "Abbrechen",
  },
  readiness: {
    title: "Übernahme",
    cr: "Als [[cr]]",
    hwr: "Als [[hwr]]",
    for_cr: "{message} (nur [[cr]])",
    for_hwr: "{message} (nur [[hwr]])",
  },
  warning: {
    UNKNOWN_ENTRY_SKIPPED: "Wird nicht übernommen",
    DUPLICATE_SKIPPED: "Doppelt, wird nur einmal übernommen",
    SUMMED: "Mehrfach genannt, Mengen werden zusammengezählt",
    CREW_OWN_TIME_NOT_ON_CONSTRUCTION_REPORT: "Eigene Zeit steht nicht [[cr:im/in der/im]] [[cr]]",
    FREE_SERVICE: "Nicht im Leistungskatalog, wird freie Leistung",
    NOT_ON_HOURLY_WAGE_REPORT: "Nicht [[hwr:im/in der/im]] [[hwr]]",
    TASK_NOT_CONVERTED: "Aufgaben kommen in keinen Bericht",
    MERGE_KEEPS_TIMES: "Arbeitszeit bleibt wie [[cr:im/in der/im]] [[cr]]",
    MERGE_KEEPS_BREAKS: "Pause bleibt wie [[cr:im/in der/im]] [[cr]]",
    MERGE_KEEPS_WEATHER: "Wetter bleibt wie [[cr:im/in der/im]] [[cr]]",
    WEATHER_TO_COMMENTS: "Kommt in die Bemerkungen",
    ADDITIONAL_EFFORT_TO_COMMENTS: "Kommt [[cr:im/in der/im]] [[cr]] in die Bemerkungen",
    NEW_RECORD: "Wird beim Speichern neu angelegt",
    RECORD_BY_NAME: "Gibt es schon in Lewara, wird zugeordnet",
    NEW_NAME_UNTRANSLATED: "Nicht übersetzt, wird so angelegt",
    MERGE_KEEPS_LINE: "Steht schon [[cr:im/in der/im]] [[cr]], bleibt wie dort",
    MERGE_INTO_PRINTED: "[[Cr]] ist gedruckt, der nächste Druck wird eine neue Fassung",
  },
  convert_cr: {
    title: "Als [[cr]] übernehmen",
    title_merge: "[[Cr]] Nr. {number} ergänzen",
    merge_text:
      "Für den {date} gibt es schon [[cr:den/die/das]] [[cr]] Nr. {number}. Die Tagesmeldung ergänzt, was darin noch fehlt; was dort steht, bleibt. In welche Schicht?",
    shift: "Schicht",
    shift_new: "Eine neue Schicht",
    shift_n: "Schicht {n}: {from}–{to}",
  },
  convert_hwr: {
    title: "Als [[hwr]] übernehmen",
  },
  // Was vor dem Editor zu wählen ist: die Baustelle einer Tagesmeldung ohne
  convert: {
    site_text: "Die Tagesmeldung nennt keine Baustelle. Für welche soll der Bericht sein?",
    site: "Baustelle",
    site_nearby: "In der Nähe des Aufnahmeorts: {sites}.",
    site_distance: "{name} ({meters} m)",
    open: "Im Editor öffnen",
  },
  // Über dem Bericht, den eine Tagesmeldung gefüllt hat
  report: {
    notice: "Aus der Tagesmeldung",
    from_sender: "Aus der Tagesmeldung von {name} vom {date}",
    from: "Aus der Tagesmeldung vom {date}",
    // Eingeklappt nur die Zahlen; aufgeklappt eine Zeile je Punkt
    gaps: "{count} zu ergänzen | {count} zu ergänzen",
    hints: "{count} Hinweis | {count} Hinweise",
    show: "Punkte anzeigen",
    hide: "Punkte ausblenden",
    made: "Beim Speichern neu angelegt, noch ohne Preise",
    weather_subject: "Wetter ({at})",
    changed:
      "Der Bericht des Tages wurde inzwischen geändert. Öffnen Sie die Tagesmeldung neu, um auf dem neuen Stand zu ergänzen.",
    redraft: "Neu öffnen",
  },
  // Was ein Bericht aus der Tagesmeldung nicht hat, im Editor zu ergänzen: kurz, für sich lesbar, unter dem Eintrag
  // oder mit ihm genannt
  gap: {
    project_missing: "Keine Baustelle angegeben",
    entry_unlinked: "Nicht in Lewara gefunden",
    entry_record_missing: "In Lewara gelöscht",
    position_record_missing: "Personalrolle in Lewara gelöscht",
    new_record_forbidden: "Nicht in Lewara, anlegen dürfen Sie es nicht",
    crew_position_missing: "Ohne Personalrolle",
    device_number_missing: "Ohne Geräte-Nr.",
    machine_hours_outside_shift: "Stunden passen nicht zur Arbeitszeit",
    machine_unit_unresolved: "Maschine ohne Abrechnungseinheit",
    amount_missing: "Ohne Menge",
    amount_not_integer: "Menge mit Nachkommastellen",
    unit_mismatch: "In anderer Einheit gesagt",
    quantity_missing: "Ohne Menge",
    service_not_bookable: "Position nicht buchbar",
    times_missing: "Arbeitszeit unvollständig",
    times_missing_start: "Arbeitsbeginn fehlt",
    times_missing_end: "Feierabend fehlt",
    pause_without_times: "Nur Dauer, ohne Uhrzeit",
    weather_incomplete: "Wetter unvollständig",
    crew_or_machine_missing: "Kein Mitarbeiter und keine Maschine",
    nothing_to_report: "Keine Leistung, Arbeit oder Vorkommnis",
    nothing_to_book: "Kein Mitarbeiter, keine Maschine, kein Material, keine Zusätzliche Leistung",
    hours_unknown: "Ohne Stunden",
    merge_manual_cost_split: "Kosten von Hand verteilt, Anteil der neuen Leistung fehlt",
    people_unlinked: "Ein Mitarbeiter nicht in Lewara gefunden",
    people_gone: "Ein Mitarbeiter in Lewara gelöscht",
    people_position: "Ein Mitarbeiter ohne Personalrolle",
    people_hours: "Ein Mitarbeiter ohne Stunden",
  },
  dismiss: {
    title: "Tagesmeldung verwerfen",
    text: "Aus der Tagesmeldung wird kein Bericht. In der App sieht der Mitarbeiter nicht, dass sie verworfen wurde.",
    note: "Notiz (intern, optional)",
    confirm: "Verwerfen",
  },
  comments: {
    title: "Kommentare des Mitarbeiters",
    after_status: "nach der Übernahme",
  },
  // Wo das Gerät beim Start der Aufnahmen war (auf der Karte, nahe beieinander als ein Ort), und die
  // Baustellen in der Nähe. Nie die Koordinaten als Text.
  location: {
    recorded: "Aufgenommen",
    // Nur wo der Ort mehr als 100 m daneben liegen kann
    vague_m: "Nur auf etwa {meters} m genau",
    vague_km: "Nur auf etwa {km} km genau",
    map: "Karte der Aufnahmeorte",
    site: "Baustelle",
    nearby: "In der Nähe",
    distance_m: "{meters} m entfernt",
    distance_km: "{km} km entfernt",
    chosen: "Gewählt",
    none_nearby: "Keine Baustelle mit Koordinaten im Umkreis von 10 km",
    // Ohne Standort: ob die App noch sucht (bis 15 Minuten nach dem Senden), keinen fand oder keinen sandte
    location: "Standort",
    searching: "Wird noch bestimmt",
    searching_hint: "Das Handy fand beim Senden keinen. Die App reicht ihn bis {time} Uhr nach.",
    unavailable: "Nicht bestimmbar",
    unavailable_hint: "Das Handy fand auch in den 15 Minuten nach dem Senden keinen.",
    none: "Nicht übermittelt",
    // Ein Standort, den das Handy erst nach dem Senden fand
    after_sending: "Nach dem Senden bestimmt",
    after_sending_minutes: "{minutes} Min. nach dem Senden",
    after_sending_soon: "Kurz nach dem Senden",
  },
  // Eine Stunde, die eine neue Schicht des Bautagesberichts bekommt und der Verlauf nicht hat
  weather: {
    recorded: "Bei der Aufnahme gemessen",
    said: "Laut Mitarbeiter",
    office: "Von Ihnen eingetragen",
    missing: "Fehlt",
    none: "Für den Tag liegt kein Wetter vor.",
  },
  snackbar: {
    converted_cr: "[[Cr]] Nr. {number} erstellt.",
    merged_cr: "[[Cr]] Nr. {number} ergänzt.",
    converted_hwr: "[[Hwr]] Nr. {number} erstellt.",
    dismissed: "Tagesmeldung verworfen.",
    reopened: "Tagesmeldung wieder geöffnet.",
  },
}
